import { React, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

import axios from 'axios';
import { Global } from '../../../Global';

import NumberFormat from 'react-number-format';


import Loading from '../../../elementos/Loading';
import HeaderVista from '../../../elementos/HeaderVista';
import TituloMini from '../../../elementos/TituloMini';
import CheckboxList from '../../../elementos/CheckboxList';
import Input from '../../../elementos/Input';
import Error from '../../../elementos/Error';
import Select from '../../../elementos/Select';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';


import CheckIcon from '@mui/icons-material/Check';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ConfirmDelete from '../../../elementos/ConfirmDelete';
import ClienteEditMediosDePagoPorAgendaCrear from './ClienteEditMediosDePagoPorAgendaCrear';
import ClienteEditMediosDePagoPorAgendaUpdate from './ClienteEditMediosDePagoPorAgendaUpdate';


export default function ClienteEditMediosDePagoPorAgenda({ dominio, agendas }) {

    const [estadoVista, setEstadoVista] = useState('loading');
    const [finalizado, setFinalizado] = useState(true);

    const [registros, setRegistros] = useState([]);


    const handleRefresh = () => {
        setFinalizado(true);
    }

    useEffect(() => {
        if (finalizado) {
            axios.get(`${Global.url_api}cliente/medios-de-pago-por-agenda/${dominio}`, { headers: { Authorization: localStorage.getItem("token") } })
                .then(res => {

                    setEstadoVista('cargado');
                    setFinalizado(false);
                    setRegistros(res.data);

                })
                .catch((error) => {
                    console.log(error?.response?.data);
                    setEstadoVista('error')
                });
        }
    }, [finalizado]);




    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error />)

    if (estadoVista === 'cargado')
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} md={9} >
                    <TituloMini titulo="Mercadopago por Agenda">Aquí podrás indicar un Access Token específico para una determinada agenda</TituloMini>
                </Grid>
                <Grid item xs={12} md={3} align="right">
                    <ClienteEditMediosDePagoPorAgendaCrear dominio={dominio} agendas={agendas} refreshFunction={handleRefresh} />
                </Grid>
                <Grid item xs={12} >
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Agenda</TableCell>
                                <TableCell align="right">Valor</TableCell>
                                <TableCell align="center">Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {registros.map((row) => (
                                <TableRow
                                    key={row._id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.agenda}
                                    </TableCell>
                                    <TableCell align="right">
                                        {
                                            [1, 2].indexOf(row.importe_debe) >= 0 &&
                                            <NumberFormat
                                                value={(row.importe_debe > 1 ? row.importe_valor * 100 : row.importe_valor)}
                                                className="foo"
                                                displayType={'text'}
                                                decimalSeparator=","
                                                thousandSeparator="."
                                                prefix={(row.importe_debe < 2 ? '$ ' : '')}
                                                suffix={(row.importe_debe > 1 ? ' %' : '')}
                                            />
                                        }
                                        {
                                            row.importe_debe === 3 &&
                                            <>Paga en Local (no cobra seña)</>
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        <ClienteEditMediosDePagoPorAgendaUpdate
                                            dominio={dominio}
                                            refreshFunction={handleRefresh}
                                            idInit={row._id.toString()}
                                            puestoInit={row.puestoCodigo}
                                            importeDebeInit={row.importe_debe}
                                            importeValorInit={row.importe_valor}
                                            agendas={agendas}
                                        />
                                        <ConfirmDelete
                                            variant="outlined"
                                            size="small"
                                            httpDelete={`cliente/medios-de-pago-por-agenda/${dominio}/${row._id}`}
                                            refreshFunction={handleRefresh}
                                            soloIcono
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        )

}